import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import { SetState } from 'src/types/generic';

function useDebouncedValue<T>(
  value: T,
  delay: number,
  setAreLineItemsDebouncing: SetState<boolean>
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    setAreLineItemsDebouncing(true);
    const timer = setTimeout(() => {
      setAreLineItemsDebouncing(false);
      setDebouncedValue((prev) => (isEqual(prev, value) ? prev : value));
    }, delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay, setAreLineItemsDebouncing]);

  return debouncedValue;
}

export default useDebouncedValue;
